import { useContext } from 'react';
import { StoreContext } from '..';
import { DataStore } from '../store';

const useStores = (): DataStore => useContext(StoreContext)!;

export default useStores;
